import { PayloadAction } from '@reduxjs/toolkit';
import {
  RetailResponse,
  RegionResponse,
  BranchResponse,
  MeetingRoomsResponse,
} from './state';
import {
  Branch,
  Office,
  MetaOffice,
  Retail,
  RemainingHours,
  MeetingRoom,
  Reservation,
} from './type';

const reducers = {
  getBranches(state, action: PayloadAction<BranchResponse>) {
    state.branches = action.payload;
    return state;
  },
  getFavoriteBranches(state, action: PayloadAction<BranchResponse>) {
    state.favorite_branches = action.payload;
    return state;
  },
  getBranch(state, action: PayloadAction<Branch>) {
    state.branch = action.payload;
    return state;
  },
  getRegions(state, action: PayloadAction<RegionResponse>) {
    state.regions = action.payload;
    return state;
  },
  getOffices(state, action: PayloadAction<Office[]>) {
    state.offices = action.payload;
    return state;
  },
  getMetaOffice(state, action: PayloadAction<MetaOffice>) {
    state.meta_offices = action.payload;
    return state;
  },
  getMeetingRoom(state, action: PayloadAction<MeetingRoom>) {
    state.meeting_room = action.payload;
    return state;
  },
  getMeetingRooms(state, action: PayloadAction<MeetingRoomsResponse>) {
    state.meeting_rooms = action.payload;
    return state;
  },
  getRetails(state, action: PayloadAction<RetailResponse>) {
    state.retails = action.payload;
    return state;
  },
  getRetail(state, action: PayloadAction<Retail>) {
    state.retail = action.payload;
    return state;
  },
  getRemainingHours(state, action: PayloadAction<RemainingHours>) {
    state.remaining_hours = action.payload;
    return state;
  },
  getReservations(state, action: PayloadAction<Reservation[]>) {
    state.reservations = action.payload;
    return state;
  },
};

export default reducers;
